module.exports = __webpack_public_path__ + "static/media/slideshow (4).3b7e1f37.png";